import { render, staticRenderFns } from "./oil_price_show.vue?vue&type=template&id=cb063f3e&scoped=true&"
import script from "./oil_price_show.vue?vue&type=script&lang=js&"
export * from "./oil_price_show.vue?vue&type=script&lang=js&"
import style0 from "./oil_price_show.vue?vue&type=style&index=0&id=cb063f3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb063f3e",
  null
  
)

export default component.exports